import actionTypes from '../constants/actionTypes'
import { scoreboard as sbParser } from '../lib/transform/parsers/cricket'
import { filterEvent } from './helpers'

export default function scoreboardReducer(state = {}, action) {
  switch (action.type) {
    case actionTypes.UPDATE_TIMEZONE:
      var { params = {}, query = {} } = action
      sbParser.setLocalTime(state.leagues || [], state.scoreboardType || '', params.sport || '')
      var activeDates = sbParser.getActiveDates(state.leagues || [])
      var date = sbParser.getDate(state.apiDate, params, query)
      return Object.assign({}, state, {
        activeDates: activeDates,
        zone: action.zone,
        date
      })

    case actionTypes.GET_GEO_LOCATION:
      var { country } = action.data

      return Object.assign({}, state, {
        ...action.data,
        country
      })
    case actionTypes.UPDATE_FAVORITES:
      return filterEvent(state, state, false, action.data)
    case actionTypes.GET_SCOREBOARD:
      var actionData = action.data
      var { sport = '', league, team } = action.params
      if (league || team || sport !== 'cricket') {
        return Object.assign({}, state, {
          ...actionData,
          loading: false
        })
      } else {
        return filterEvent(state, actionData, true)
      }

    case actionTypes.GET_TOPEVENTS:
      return filterEvent(state, action.data, false)

    case actionTypes.GET_SCOREBOARD_REQUEST:
      return Object.assign({}, state, {
        loading: action.isPolling ? false : true
      })

    case actionTypes.HISTORY_CHANGE:
    case actionTypes.GET_SCOREBOARD_FAILURE:
      return Object.assign({}, state, {
        loading: false
      })

    case actionTypes.RESET_SCOREBOARD:
      return {}

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/scoreboard.js